import { render } from "./TemplateForm.vue?vue&type=template&id=3d26b724&ts=true"
import script from "./TemplateForm.vue?vue&type=script&lang=ts"
export * from "./TemplateForm.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/alarm-receiver-frontend/alarm-receiver-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__